const PATH = 'smartcargas/policy';

export default PATH;
